import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface AnnouncementBanner {
  message: string;
  releaseDate: string;
  isActive: boolean;
  expiresIn: string;
  expiresAt: Timestamp;
  updatedAt: Timestamp;
  ctaUrl?: string;
  ctaText?: string;
}

export const saveAnnouncementBanner = async (announcement: AnnouncementBanner): Promise<void> => {
  try {
    const announcementRef = doc(db, 'system', 'announcementBanner');
    await setDoc(announcementRef, announcement);
    
    // Réinitialiser le localStorage pour tous les utilisateurs
    localStorage.removeItem('announcementBannerClosedAt');
  } catch (error) {
    console.error('Error saving announcement banner:', error);
    throw error;
  }
};

export const getAnnouncementBanner = async (): Promise<AnnouncementBanner | null> => {
  try {
    const announcementRef = doc(db, 'system', 'announcementBanner');
    const announcementDoc = await getDoc(announcementRef);
    
    if (announcementDoc.exists()) {
      const data = announcementDoc.data() as AnnouncementBanner;
      
      // Vérifier si l'annonce est expirée
      if (data.expiresAt && data.expiresAt.toDate() < new Date()) {
        return null;
      }
      
      return data;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting announcement banner:', error);
    return null;
  }
};